import isEqual from 'lodash/isEqual';

import {createTextareaField, disableFormControls} from '../forms/formFields';
import {cloneValue} from '../forms/formState';

const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const normalizeString = value => typeof value === 'undefined' || value === null ? '' : String(value);

const normalizeJQTask = task => {
    if (!isPlainObject(task)) {
        return {
            filter: ''
        };
    }

    return {
        ...cloneValue(task),
        filter: normalizeString(task.filter)
    };
};

const getResource = (mxResources, key) => mxResources.get(key);

const createJQTaskForm = ({
                              task = {},
                              taskErrors = {},
                              editable = true,
                              mxResources,
                              onJQChange = () => {},
                              onTestJQFilter = () => {}
                          } = {}) => {
    let jqTask = normalizeJQTask(task);

    const container = document.createElement('div');
    container.id = 'jqEditor';
    container.className = 'ui form';

    const helpParagraph = document.createElement('p');
    helpParagraph.appendChild(document.createTextNode(getResource(mxResources, 'jqFilterHelpPrefix')));
    const helpLink = document.createElement('a');
    helpLink.target = '_blank';
    helpLink.rel = 'noopener noreferrer';
    helpLink.href = 'https://stedolan.github.io/jq/manual/v1.6/';
    helpLink.textContent = getResource(mxResources, 'jqFilterHelpLink');
    helpParagraph.appendChild(helpLink);
    helpParagraph.appendChild(document.createTextNode(getResource(mxResources, 'jqFilterHelpSuffix')));
    container.appendChild(helpParagraph);

    const filterField = createTextareaField({
        label: getResource(mxResources, 'jqFilter'),
        id: 'filter',
        name: 'filter',
        rows: 5,
        className: 'required',
        value: jqTask.filter,
        error: taskErrors?.fields?.filter
    });
    const filterTextarea = filterField.querySelector('textarea');
    filterTextarea.value = jqTask.filter;
    filterTextarea.addEventListener('change', event => emitJQ({filter: event.target.value}));
    container.appendChild(filterField);

    const testJQFilterButton = document.createElement('button');
    testJQFilterButton.id = 'testJQFilter';
    testJQFilterButton.type = 'button';
    testJQFilterButton.className = 'ui mini compact button';
    testJQFilterButton.textContent = getResource(mxResources, 'testJQFilter');

    const testJQFilterField = document.createElement('div');
    testJQFilterField.id = 'testJQFilterField';
    testJQFilterField.className = 'field';
    testJQFilterField.appendChild(testJQFilterButton);
    testJQFilterField.addEventListener('click', event => onTestJQFilter({
        event,
        task: cloneValue(jqTask),
        filter: jqTask.filter
    }));
    container.appendChild(testJQFilterField);

    const syncStructuredFields = () => {
        filterTextarea.value = jqTask.filter;
    };

    function emitJQ(patch) {
        const nextJQTask = normalizeJQTask({
            ...jqTask,
            ...patch
        });

        if (isEqual(jqTask, nextJQTask)) {
            return;
        }

        jqTask = nextJQTask;
        task.filter = jqTask.filter;
        onJQChange({filter: jqTask.filter}, cloneValue(jqTask));
    }

    if (!editable) {
        disableFormControls(container);
    }

    return {
        element: container,
        getTask: () => cloneValue(jqTask),
        setTask: value => {
            jqTask = normalizeJQTask(value);
            task.filter = jqTask.filter;
            syncStructuredFields();
        }
    };
};

export {
    createJQTaskForm,
    normalizeJQTask
};
